//
//  src/layouts/depict/gallery/Gallery.js
//
import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Nav      from "../../../components/nav/Nav"
import Wall     from "../../../components/wall/Wall"
import Footer   from "../../../components/footer/Footer"


//
//  gallery
//
export default function Gallery() {
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com/gallery';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    const pageTitle = 'Tattoo Gallery | Realistic Tattoo Artwork by Jeff Tattooer';
    const pageDescription = 'Browse our tattoo gallery featuring realistic tattoo artwork, blackwork, traditional, and neo-traditional designs. View Jeff Tattooer\'s portfolio.';
    
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": pageTitle,
        "description": pageDescription,
        "url": canonicalUrl,
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://jefftattooer.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Gallery",
                    "item": canonicalUrl
                }
            ]
        }
    };
    
    return (
        <div id="gallery">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <Nav      />
            <Wall     />
            <Footer   />
        </div>
    );
}
